import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Paginator } from "src/app/shared/models/paginator";
import { environment } from "src/environments/environment";
import { Reporte } from "../reports/models/reporte";
import { BoardSource, ConfigResponse } from "./config-response";

@Injectable({
  providedIn: 'root'
})
export class BoardsService {

  constructor(private http: HttpClient) { }
  /**
   * Gets the reports by area
   * @param {string} areaId
   * @param {number} page
   * @param {string} reportType
   * @returns {Observable<Paginator<Reporte>>}
   */
  getBoardsByArea(areaId: string, reportType: string, page = 0): Observable<Paginator<Reporte>> {
    return this.http.get<Paginator<Reporte>>(`${environment.urlBase}/report/area/${areaId}?pagina=${page}&tipoReporte=${reportType}`);
  }

  /**
   * Returns the object with the information of a specific board
   * @param {string} boardId
   * @returns {Observable<Reporte>}
   */
  getBoard(boardId: string): Observable<Reporte> {
    return this.http.get<Reporte>(`${environment.urlBase}/report/${boardId}`);
  }

  /**
   * This method returns the embed configuration for a specific board
   * @param {BoardSource} boardSource
   * @returns {Observable<ConfigResponse>}
   */
  getBoardEmbedConfig(boardSource: BoardSource): Observable<ConfigResponse> {
    return this.http.post<ConfigResponse>(`${environment.urlBase}/report/getembedinfo`, boardSource);
  }

  /**
   * Creates a new board
   * @param {Reporte} board
   * @returns {Observable<Reporte>}
   */
  createBoard(board: Reporte): Observable<Reporte> {
    return this.http.post<Reporte>(`${environment.urlBase}/report/`, board);
  }

  /**
   * This method disables a specific board
   * @param {string} boardId
   * @returns {Observable<Reporte>}
   */
  disableBoard(boardId: string): Observable<Reporte> {
    return this.http.put<Reporte>(`${environment.urlBase}/report/${boardId}`, null);
  }

  /**
   * Updates the favorite property of the board
   * @param {string} boardId
   * @returns {Observable<boolean>}
   */
  setFavorite(boardId: string): Observable<boolean> {
    return this.http.put<boolean>(`${environment.urlBase}/favorite/report/${boardId}`, null);
  }

  deleteReport(uuid: string) {
    return this.http.delete<Reporte>(`${environment.urlBase}/report/${uuid}`);
  }
}
